import React from 'react';
import CommonSidebar from "../Common/CommonSidebar";

// components
import UserSubscriberContext from "../../context/UserSubscriberContext";
import retrievePermission from "../../utils/retrievePermission";
import AccountCreateModal from "../Account/AccountCreateModal";

//icons
import ApartmentIcon from '@mui/icons-material/Apartment';
import ContactPageIcon from '@mui/icons-material/ContactPage';
import LocalPhoneIcon from '@mui/icons-material/LocalPhone';


class AccountSidebar extends React.Component {
    static contextType = UserSubscriberContext

    constructor(props) {
        super(props);
        this.state = {
            additionalGroups: [],
            accountCreatePermission: 0,
        };
    }

    async componentDidMount() {
        await this.retrieveCallPermission();
        await this.retrieveAccountCreatePermission();
    }

    async retrieveAccountCreatePermission() {
        let p = 0;
        p += await retrievePermission(
            'AccountViewSet',
            'create_by_tax',
            this.context.subscriberObject
        );
        this.setState({
            accountCreatePermission: p
        })
    }

    async retrieveCallPermission(){
        let p = 0;
        p += await retrievePermission(
            'SunsimCallViewSet',
            'list',
            this.context.subscriberObject
        );
        if (p){
            this.setState(
            {
                    additionalGroups: [
                        ...this.state.additionalGroups,
                        {
                            title: 'Дополнительно',
                            items: [
                                {
                                    title: 'Звонки',
                                    link: '/call/',
                                    icon: LocalPhoneIcon,
                                },
                            ],
                        },
                    ]
                }
            );
        }
    }

    render() {
        return(
            <CommonSidebar
                groups={[ ...[
                    {
                        title: 'Контрагенты',
                        items: [
                            ...this.state.accountCreatePermission?[
                                {
                                type: 'component',
                                component: <AccountCreateModal />
                            },
                            ]:[],
                            {
                                title: 'Компании',
                                link: '/account/',
                                icon: ApartmentIcon,
                            },
                            {
                                title: 'Контакты',
                                link: '/contact/',
                                icon: ContactPageIcon,
                            }
                        ]
                    }
                    ], ...this.state.additionalGroups
                ]}
            />
        )
    }
}

export default AccountSidebar;
